<template>
  <div
    class="addFile"
    v-if="visible"
  >
    <template v-if="text">
      <p>
      {{text}}
      </p>
    </template>
    <template v-else>
      <i class="el-icon-plus"></i>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      default: true
    },
    text: {
      type: String
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.addFile {
     border: 1px dashed #c0ccda;
     width: 100px;
    height: 100px;
    background: #fbfdff;
  color: #e2dddd;
  display: flex;
  justify-content: center;
  align-items: center;
      float: right;
  i {
       font-size: 24px;
    color: #8c939d;
  }
}
</style>



